import { render, staticRenderFns } from "./RestaurantList.vue?vue&type=template&id=dc5bcb5c"
import script from "./RestaurantList.vue?vue&type=script&lang=js"
export * from "./RestaurantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports